import { useContext } from 'react';
import type { CSSProp } from 'styled-components';
import { ThemeContext } from 'styled-components';
import type { Theme } from './types';

declare module 'styled-components' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    export interface DefaultTheme extends Theme {}
}

declare module 'react' {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    interface DOMAttributes<T> {
        css?: CSSProp;
    }
}

export const useTheme = () => useContext(ThemeContext) as Theme;

export * from './types';
export { appearance } from './app-appearance';
